
export default {
  name: 'IconSpinner',
};
